<template>
  <div class="wrapper">
    <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">Offcanvas navbar</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Dropdown
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
          </li>
        </ul>
        <form class="d-flex mt-3" role="search">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success" type="submit">Search</button>
        </form>
      </div>
    </div>
  </div>
</nav> -->
    <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light">
  <div class="container">
    <a class="navbar-brand" href="/index"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item mr10">
          <a class="nav-link" @click="hidetoggle('/fundlist')" active-class="active" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/fundlist">ファンド一覧</a>
        </li>
        <li class="nav-item mr10">
          <a class="nav-link" @click="hidetoggle('/freeMarket')" active-class="active" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/freeMarket">フリーマーケットでの購入</a>
        </li>
        <li class="nav-item mr10">
          <a class="nav-link" @click="hidetoggle('/flow')" active-class="active" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/flow">ご利用までの流れ</a>
        </li>
        <li class="nav-item mr10">
          <a class="nav-link" active-class="active" @click="hidetoggle('/profile')" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/profile">運営会社</a>
        </li>
        <li class="nav-item mr10">
          <a class="nav-link" active-class="active" @click="hidetoggle('/faq')" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/faq">FAQ</a>
        </li>
        <li class="nav-item" >
          <a class="nav-link" active-class="active" @click="hidetoggle('/contact')" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/contact">お問い合わせ</a>
        </li>
      </ul>
      <form v-if="!islogin" class="d-flex" role="search" style="align-items: center;">
        <a style="font-weight:bold;" class="mr10" @click="hidetoggle('/login')" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/login">ログイン</a>
        <a @click="hidetoggle('/registerbefore')" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="/registerbefore" style="background:#26b8bc;padding:10px;color:#fff;">
          無料会員登録はこちら</a>
      </form>
      <form v-if="islogin" class="d-flex" role="search" style="align-items: center;">
        <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="font-weight:bold;cursor: pointer;color:#0b8a8e" class="mr10" @click="tomypage()">{{userInfo.firstName ? userInfo.firstName : userInfo.email}} 様（マイページ）</a>
        <a @click="loginout" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="background:#26b8bc;padding:10px;color:#fff;cursor: pointer;">
          ログアウト</a>
      </form>
      <!-- <ul class="nav navbar-nav navbar-right" style="padding-right:15px;">
        <li class="mr10"><a href="/login">ログイン</a></li>
        <li>
          <a href="/register" style="background:#26b8bc;padding:10px;color:#fff;margin-top:10px">
            無料会員登録はこちら</a>
        </li>
      </ul> -->
    </div>
  </div>
</nav>
    <el-container>
        <!-- <div class="">
          <img style="width:130px;" src="../assets/toplogo.png" alt="">
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav firstul">
            <li><a href="fundlist.html">ファンド一覧</a></li>
            <li><a href="flow.html">ご利用までの流れ</a></li>
            <li><a href="profile.html">運営会社</a></li>
            <li><a href="faq.html">FAQ</a></li>
            <li><a href="contact.html">お問い合わせ</a></li>
          </ul>
          <ul class="nav navbar-nav navbar-right" style="padding-right:15px;">
            <li><a href="login.html">ログイン</a></li>
            <li>
              <a href="register.html" style="background:#26b8bc;padding:10px;color:#fff;margin-top:10px">
                無料会員登録はこちら</a>
            </li>
          </ul>
        </div> -->
        <!-- <el-menu
        style="font-size:1.3rem;"
        active-text-color="#1c9ea1"
        :default-active="$route.path" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/index" :route="{ path: '/index' }" @click="changeUrl('ファンド一覧','/index')">ファンド一覧</el-menu-item>
        <el-menu-item index="/index" :route="{ path: '/index' }" @click="changeUrl('ご利用までの流れ','/index')">ご利用までの流れ</el-menu-item>
        <el-menu-item index="/index" :route="{ path: '/index' }" @click="changeUrl('運営会社','/index')">運営会社</el-menu-item>
        <el-menu-item index="/index" :route="{ path: '/index' }" @click="changeUrl('FAQ','/index')">FAQ</el-menu-item>
        <el-menu-item index="/index" :route="{ path: '/index' }" @click="changeUrl('お問い合わせ','/index')">お問い合わせ</el-menu-item>
      </el-menu> -->
      <!-- <div class="text_r" style="width:350px;">
        <el-link class="mr10" href="/login" type="primary" target="_blank">ログイン</el-link>
        <el-button
          type="primary"
          class="button-login ml10"
        >無料会員登録はこちら
        </el-button>
      </div>
  </el-header>-->
  <el-main style="padding:0;text-align:left;;overflow-y: auto;">
    <keep-alive :include="cachedViews">
      <router-view @loginstatus="loginchange" :islogin="islogin" :ispass="ispass"></router-view>
    </keep-alive>
  </el-main>
  <el-footer style="padding:0;">
    <hr>
    <div class="footer-wrap">
			<div class="container">
				<div class="row">
					<div class="col-md-12 col-sm-12 col-xs-12">

						<div class="row">
							<div class="col-sm-12 col-md-5 footer-pad">
								<div class="ttl">不動産特定共同事業特化型クラウドファンディング</div>
								<div>
									<strong>運営会社</strong>
									<br>商号：株式会社繁星優選
									<br>代表者：代表取締役　劉　孝鋒
									<br>許可番号：大阪府知事第２２号
									<br>種別：第１号事業、第２号事業及び電子取引業務
									<br>本社：大阪府大阪市北区天満二丁目１−１２
									<br>TEL：06-6940-4777
									<br>業務管理者：瀬戸口　愛　公認　不動産コンサルティングマスター
								</div>
							</div>

							<div class="col-xs-12 col-sm-6 col-md-3">
								<ul class="footer-links">
									<li><a href="/flow">▶ ご利用までの流れ</a></li>
									<li><a href="/profile">▶ 運営会社概要</a></li>
									<li><a href="/meibo.pdf" target="_blank">▶ 業務管理者名簿</a></li>
									<li><a href="/terms_conditions.pdf" target="_blank">▶ 利用規約</a></li>
									<li><a href="/solicitation_policy.pdf" target="_blank">▶ 勧誘方針</a></li>
									<li><a href="/faq">▶ FAQ</a></li>
									<li><a href="/contact">▶ お問い合わせ</a></li>
								</ul>
							</div>

							<div class="col-xs-12 col-sm-6 col-md-4">
								<ul class="footer-links">
									<li><a href="/fxyx_terminate.pdf" target="_blank">▶ クーリングオフ（契約解除）について</a></li>
                  <li v-if="ispass"><a href="/coolingoffpost.pdf" target="_blank">▶ クーリングオフ申出書</a></li>
									<li><a href="/electronic_information.pdf" target="_blank">▶ 電子情報処理組織の管理に関する基本方針</a></li>
									<li><a href="/personal_information.pdf" target="_blank">▶ 個人情報保護方針</a></li>
									<li><a href="/antisocialrule.pdf" target="_blank">▶ 反社会勢力への対応</a></li>
									<li><a href="/aboutyakuin.pdf" target="_blank">▶ 当社役職員のファンド購入について</a></li>
								</ul>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div><!-- .footer-wrap -->

		<div class="copyright">
			<div class="container">
				<div class="row">
					<div class="col-md-12 col-sm-12 col-xs-12 text-center">
						<p class="copyright-text">©株式会社繁星優選 All Rights Reserved.</p>
					</div>
				</div>
			</div>
		</div>
  </el-footer>
</el-container>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  data(){
    return {
      path:"",
      activeName:"",
      menuList:[],
      menushowList:[],
      publicpmsdata:{},
      menustr:{},
      activeIndex2: '',
      cachedViews:["index"],
      isCollapse:true,
      username:"",
      userInfo:{},
      islogin:false,
      ispass:false,
    }
  },
  created(){
    this.menuList=[];
    this.menushowList=[];
    this.cachedViews=["index"];
    this.path = this.$route.path;
  },
  mounted(){
    let loginData = localStorage.getItem("loginData");
    if(loginData){
      this.islogin = true;
      if(localStorage.getItem("userInfo")){
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if(this.userInfo.status == 4){
          this.ispass = true;
        }else{
          this.ispass = false;
        }
      }else{
        this.getuserinfo();
      }
    }else{
      this.islogin = false;
    }
    // if(name){
    //   this.username=name;
    // }else {
    //   this.getInfo();
    // }
  },
  methods: {
    loginchange(res){
      if(res){
        this.islogin = true;
        this.getuserinfo();
      }
    },
    hidetoggle(url){
      this.$router.push({
        path: url
      });
    },
    getuserinfo(){
      let that = this;
      that.SV.JQajax({
        url:that._Api.userinfo,
        method:"GET",
        tvm:that,
        success: function(data) {
          console.log(data);
          if(data.code == "200"){
            that.userInfo = data.data;
            if(that.userInfo.status == 4){
              that.ispass = true;
            }else{
              that.ispass = false;
            }
            localStorage.setItem('userInfo', JSON.stringify(data.data));
          }
        },
        error:function(data){
          that.$message({
            message: data,
            type: 'warning'
          });
        }
      })
    },
    tomypage(){
      // if(this.userInfo.status == 1 || this.userInfo.status == 3){
      //   this.$router.push({
      //     path: '/userinfo'
      //   });
      // }
      // if(this.userInfo.status == 2 || this.userInfo.status == 4 ){
      //   this.$router.push({
      //     path: '/mypage'
      //   });
      // }
      if(this.userInfo.status == 0){
        if(this.userInfo.email){
          this.$message({
            message: "メールアドレスが認証されていないため、会員登録メールの本文中にあるリンクをクリックしてください。",
            type: 'warning'
          });
        }else{
          this.$router.push({
            path: '/bindemail'
          });
        }
      }else{
        this.$router.push({
          path: '/mypage'
        });
      }
    },
    getInfo(){
      var _this=this;
      this.SV.JQajax({
        url:this._Api.ownerData,
        method:"GET",
        tvm:_this,
        success: function(res) {
          // console.log(res);
          if(res.code==200){
            if(res.data.ownerName){
              localStorage.setItem('name', JSON.stringify(res.data.ownerName));
              _this.username=res.data.ownerName;
            }else{
              let userdata = JSON.parse(localStorage.getItem("loginData"));
              _this.username=userdata.usename;
            }
          }else{
            let userdata = JSON.parse(localStorage.getItem("loginData"));
            _this.username=userdata.usename;
          }
        },
        error:function(res){
          let userdata = JSON.parse(localStorage.getItem("loginData"));
          _this.username=userdata.usename;
        },
      })
    },
    loginout(){
      let that = this;
      this.$confirm('ログアウトしてよろしいですか？', 'ヒント', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        let accessToken;
        console.log(that.SV.getCookie("access_token"),accessToken);
        if(that.SV.getCookie("access_token")){
          accessToken = that.SV.getCookie("access_token");
          console.log("有cookie",accessToken);
          $.ajax({
            url : that._Api.loginUrl,
            type: "DELETE",
            contentType: "application/json;charset=utf-8",
            data:JSON.stringify({"accessToken":accessToken}),
            beforeSend: function(xhr) {
              xhr.setRequestHeader("Authorization", "Basic d2ViQXBwOndlYkFwcA==");
            },
            success: function(res) {
              localStorage.removeItem('loginData');
              localStorage.removeItem('userInfo');
              localStorage.removeItem('sellOrderinfo');
              localStorage.removeItem('fundOrderinfo');
              that.islogin = false;
              that.ispass = false;
              setTimeout(function(){
                that.$router.push({
                  path: '/login'
                });
              },100)
              that.$message({
                type: 'success',
                message: 'ログアウトしました'
              });
            },
            error:function(res){
              localStorage.removeItem('loginData');
              localStorage.removeItem('userInfo');
              localStorage.removeItem('sellOrderinfo');
              localStorage.removeItem('fundOrderinfo');
              that.islogin = false;
              that.ispass = false;
              setTimeout(function(){
                that.$router.push({
                  path: '/login'
                }).catch(() =>{});
              },100)
              that.$message({
                type: 'success',
                message: 'ログアウトしました'
              });
            }
          });
        }else{
          localStorage.removeItem('loginData');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('sellOrderinfo');
          localStorage.removeItem('fundOrderinfo');
          that.islogin = false;
          setTimeout(function(){
            that.$router.push({
              path: '/login'
            }).catch(() =>{});
          },100)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'キャンセルされました'
        });
      });
    },
  }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-header{
  position:fixed;
  top:0;
  width:100%;
  z-index:99;
  font-size:1.3rem;
}
</style>
